var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5145_7782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6399 5.23176C11.5389 5.14756 11.4222 5.08412 11.2966 5.04507C11.171 5.00603 11.0389 4.99215 10.908 5.00422C10.777 5.0163 10.6497 5.0541 10.5333 5.11545C10.417 5.1768 10.3139 5.2605 10.2299 5.36176L5.22993 11.3618C5.08285 11.5407 5.00244 11.7651 5.00244 11.9968C5.00244 12.2284 5.08285 12.4528 5.22993 12.6318L10.0599 18.6318C10.154 18.7478 10.273 18.8412 10.4079 18.9053C10.5429 18.9693 10.6905 19.0023 10.8399 19.0018C11.0292 19.0024 11.2147 18.9493 11.375 18.8487C11.5353 18.7481 11.6637 18.6041 11.7454 18.4334C11.8271 18.2627 11.8586 18.0723 11.8364 17.8844C11.8142 17.6965 11.7391 17.5187 11.6199 17.3718L7.28993 12.0018L11.7699 6.63176C11.9369 6.42826 12.0169 6.16714 11.9925 5.90506C11.9682 5.64297 11.8415 5.40104 11.6399 5.23176Z",
    fill: "#FC5719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2899 11.9995L18.7699 6.62953C18.9397 6.42532 19.0213 6.16204 18.997 5.89761C18.9726 5.63318 18.8441 5.38927 18.6399 5.21953C18.4357 5.04979 18.1724 4.96813 17.908 4.99251C17.6436 5.01689 17.3997 5.14532 17.2299 5.34953L12.2299 11.3495C12.0828 11.5285 12.0024 11.7529 12.0024 11.9845C12.0024 12.2162 12.0828 12.4406 12.2299 12.6195L17.0599 18.6195C17.154 18.7356 17.273 18.829 17.4079 18.893C17.5429 18.9571 17.6905 18.99 17.8399 18.9895C18.0292 18.9902 18.2147 18.9371 18.375 18.8365C18.5353 18.7359 18.6637 18.5919 18.7454 18.4212C18.8271 18.2505 18.8586 18.0601 18.8364 17.8722C18.8142 17.6843 18.7392 17.5065 18.6199 17.3595L14.2899 11.9995Z",
    fill: "#FC5719"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5145_7782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.54a85d01def372963267c9a15170c64b.svg";
export { ForwardRef as ReactComponent };